import './App.css';
import {Navigate, Route, Routes} from "react-router-dom";
import pleshDark from "./theme/pleshDark";
import Vote from "./pages/Vote";
import React from "react";
import {CssBaseline, ThemeProvider} from "@mui/material";
import Home from "./pages/Home";

function App() {
    return (
        <ThemeProvider theme={pleshDark}>
            <CssBaseline/>
            <div className="App">
                <Routes>
                    {/** TODO: Quando si crea il branch di un evento specifico: Eliminare la route a <Home/>*/}
                    {/*<Route path='/' element={<Home/>}/>*/}

                    {/** TODO: Quando si crea il branch di un evento: Scommentare e sostituire:
                     * - eventOwnerId con l'ID dell'utente proprietario dell'evento (nel caso di Plesh l'id è `plesh`)
                     * - eventId con l'ID dell'evento
                     */}
                    <Route path='/' element={<Navigate to={'/vote/plesh/dWX6aZT1r361w4je6UiD'}/>}/>
                    <Route path='/napoli' element={<Navigate to={'/vote/plesh/JZUBjoyQptsQxLe3Ew9g'}/>}/>
                    <Route path='/bologna' element={<Navigate to={'/vote/plesh/3e4Qpd8Ez8sKuw3KhbAh'}/>}/>
                    <Route path='/torino' element={<Navigate to={'/vote/plesh/dWX6aZT1r361w4je6UiD'}/>}/>
                    <Route path='/vote/:eventOwnerId/:id' element={<Vote/>}/>
                </Routes>
            </div>
        </ThemeProvider>
    );
}

export default App;
